import {
  Component,
  Input,
  AfterContentInit,
  Optional,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import { PlycaDataService } from '../../../services/plyca.service';
import { InterfaceSettings, FieldGroup, InterfaceDisplayType, FieldConfig, FormUpdateMode } from '../../api/contract-notice-dto';
import {
  ErrorForm,
  FormConfig,
  FormGroupConfig,
  FormAction,
  FormDialogResponse,
  ErrorDefinition,
  ErrorFieldGroup
} from './form.objects';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from './form.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, forkJoin, of, throwError, Subject, timer } from 'rxjs';
import { map, tap, catchError, debounce, take } from 'rxjs/operators';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { HelpService } from '../common/help/help.service';
import { HeaderActionsService } from '../common/sub-header/header-actions.service';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';
import { getResultTypeDTOLevel, ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseComponent } from '../common/baseComponent/base.component';
import { HelpElementDTO } from '../common/help/help.dtos';
import { UserService } from '../../user.service';
import { MainViewPrefs, UserPrefs } from '../../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { SET_USERPREFS } from '../../store/userPrefs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { VisibilityEvent } from './formElement.component';

@Component({
  selector: 'formPlyca',
  templateUrl: 'formPlyca.template.html',
  providers: [DialogService]
})
export class formPlycaComponent extends BaseComponent implements AfterContentInit, OnInit, OnChanges, OnDestroy {
  loaded = false;
  private formLoaded = false;
  @Input() formConfig: FormConfig;
  @Input() manageWaitService = true;

  private viewUpdates = new Subject<boolean>();

  // control de carga
  completed: Subject<boolean>;
  formGroup: FormGroup;
  groups: FormGroupConfig[] = [];
  // validaciones: ValidationResultDTO;
  errorForm: ErrorForm;
  // lista de componentes formGroup pendientes de carga
  private loadingSubcomponentIds = new Array<string>();
  private lastChangesApplied = null;

  windowHash: string;
  isModalWindow = false;

  showValidationsPanel = false;

  public InterfaceDisplayType = InterfaceDisplayType;
  public showIndex = false;

  userPrefs: UserPrefs;
  public emptyGroup = new Map<String, Boolean>();

  constructor(
    public plycaService: PlycaDataService,
    public formService: FormService,
    public translate: TranslateService,
    private fb: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    public uiService: UIService,
    private focusTrap: FocusTrapFactory,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
    public helpService: HelpService,
    private waitService: WaitLoadingService,
    public userService: UserService,
    private store: Store<AppState>,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig
  ) {
    super();
    this.completed = new Subject();
    this.subscribe(this.store.select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.mainViewPrefs) {
          this.userPrefs.mainViewPrefs = new MainViewPrefs();
        }
      });
  }

  private createFormInterface(formformConfig: FormConfig) {
    if (this.manageWaitService) {
      this.waitService.startWaiting();
    }
    this.formConfig = formformConfig;
    // crear grupo de formularios
    let tmpFormGroup = this.fb.group({});

    this.showValidationsPanel = this.formConfig.showValidations;
    this.groups = [];

    if (this.formConfig.interfaceSetting.updateMode === FormUpdateMode.ONCHANGE) {
      console.log('Formulario configurado para actualizarse tras cambios en el modelo');
      this.subscribe(this.viewUpdates.pipe(
        debounce(() => timer(250)),
        tap((value: any) => {
          if (value && this.isLoaded()) {
            this.updateGroupView(value);
          }
        })
      ));
    } else {
      console.log('Formulario configurado para actualizarse a traves de un timer');
    }

    console.log('ANTES DE PARCHEAR GRUPOS');
    this.subscribe(this.patchFormGroups(this.formConfig.interfaceSetting.fieldGroups), () => {
      console.log('DESPUES DE PARCHEAR GRUPOS');

      // asignar grupo de formularios a subgrupos
      this.formConfig.interfaceSetting.fieldGroups.forEach(
        (fieldGroup: FieldGroup, index: number) => {
          fieldGroup.interfaceSettings = this.formConfig.interfaceSetting;
          fieldGroup.formGroup = tmpFormGroup;
          fieldGroup.active = index === 0;
          let config = new FormGroupConfig(
            fieldGroup,
            this.formConfig.model,
            undefined,
            undefined,
            this.formConfig.readonly
          );
          // TODO: Revisar. Por ahora copiamos las funciones. Buscar una forma mejor de hacer llegar las funciones a los elementos
          config.functions = this.formConfig.functions;
          config.templates = this.formConfig.templates;
          this.groups.push(config);
        });
      this.errorForm = new ErrorForm(
        this.formConfig
      );
      this.formGroup = tmpFormGroup;
      this.loaded = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  patchFormGroup(group: FieldGroup): Observable<any> {
    console.log('patchFormGroup', group.fieldSettingsFile);
    return this.plycaService.getInterfaceSettings(group.fieldSettingsFile).pipe(
      map((settings: InterfaceSettings) => {
        group.fieldList = settings.fieldGroups[0].fieldList;
        console.log('GRUPO PARCHEADO');
      })
    );
  }

  public updateView(): void {
    this.lastChangesApplied = new Date();
  }

  public markAsDirty(): void {
    this.formGroup.markAsDirty();
  }

  // cargar lista de campos de aquellos grupos cuya definición está en un fichero independiente
  patchFormGroups(groups: FieldGroup[]): Observable<any> {
    let observables: Observable<any>[] = [];
    groups.forEach((group: FieldGroup) => {
      if (group.fieldSettingsFile) {
        observables.push(this.patchFormGroup(group));
      }
    });
    if (observables.length > 0) {
      console.log('lista de observables', observables.length);
      return forkJoin(observables);
    } else {
      console.log('lista de observables vacia');
      return of('');
    }
  }

  ngAfterContentInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      let formConfigChanges = changes.formConfig;
      if (formConfigChanges && !formConfigChanges.firstChange &&
        formConfigChanges.previousValue !== formConfigChanges.currentValue) {
        if (this.formConfig) {
          this.load(this.formConfig);
        }
      }
    }
  }

  ngOnInit(): void {
    if ((!this.formConfig && this.dialogConfig['formConfig'] !== undefined)
      || (this.formConfig && this.formConfig.isModalWindow)) {
      this.isModalWindow = true;


      if (!this.formConfig) {
        this.formConfig = this.dialogConfig['formConfig'];
        if (this.dialogConfig['readonly']) {
          this.formConfig.readonly = this.dialogConfig['readonly'];
        }
      }
      if (this.formConfig.windowHash) {
        this.windowHash = this.formConfig.windowHash;
      } else {
        /* INI TODO-AYUDA-MODAL-FORM Se está cargando la info de la ayuda contextual en modales, Pendiente de pintar en subheader */
        this.windowHash = generateRandomIdentifier();
      }



      if (this.formConfig.actions) {

        this.loadActions();
      }
      /* FIN TODO-AYUDA-MODAL-FORM*/
    }
    if (this.formConfig && !this.formGroup) {
      this.load(this.formConfig);
    }
    if (this.isModalWindow) {
      this.setModalHelpContext();
    }
  }

  loadActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);

    console.log('ACCIONES...');
    console.log(this.formConfig.actions);

    this.formConfig.actions.forEach((fieldGroup: FormAction<any>) => {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          fieldGroup.buttonTextKey,
          fieldGroup.imageClass,
          fieldGroup.buttonClass,
          true,
          this.windowHash
        ), () => {
          this.executeAction(fieldGroup);
        });
    });
  }

  public load(formConfig: FormConfig) {
    this.loaded = false;
    this.formLoaded = false;
    this.formConfig = formConfig;
    this.completed.next(false);
    console.log('Iniciando formulario', formConfig);
    console.log(
      'checking this.formConfig.interfaceSetting: ',
      formConfig.interfaceSetting
    );
    if (!formConfig.interfaceSetting) {
      console.log(
        'cargando definicion de formulario por id',
        formConfig.interfaceSettingsId
      );
      // recuperar la definicion del formulario en funcion del Id
      this.subscribe(this.plycaService
        .getInterfaceSettings(formConfig.interfaceSettingsId), (settings: InterfaceSettings) => {
          formConfig.interfaceSetting = settings;
          this.subscribe(this.helpService.searchByForm(formConfig.interfaceSettingsId, [formConfig.model]),
            result => {
              if (result && result.content) {
                result.content.forEach((element: HelpElementDTO) => {
                  element.tags.forEach(tags => {
                    let tagArray = tags.split('&');
                    tagArray.forEach((value, index) => {
                      if (value.startsWith('FLD_') && index + 1 < tagArray.length)
                        settings.fieldGroups.forEach(group => {
                          group.fieldList.filter((field: FieldConfig) => field.jsonField == tagArray[index + 1])
                            .forEach((field: FieldConfig) => {
                              if (!field.helpEntries)
                                field.helpEntries = [];
                              field.helpEntries.push(tagArray[index]);
                              field.helpEntries.push(tagArray[index + 1]);
                            });
                        });
                    });
                  });
                });
              }
              formConfig.interfaceSetting.fieldGroups.forEach(group =>
                group.fieldList.forEach((field: FieldConfig) => {
                  field.formId = formConfig.interfaceSettingsId.replace('.json', '');
                  field.showInfo = (this.userService.hasRoles('0,50') && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags);
                }));

              // -->
              this.loadingSubcomponentIds = new Array<string>();
              this.formConfig.interfaceSetting.fieldGroups.forEach(
                (fieldGroup: FieldGroup) => {
                  if (fieldGroup.id === undefined) {
                    throw new Error(
                      'Error existe un grupo en la definicion del formulario sin id:'
                    );
                  } else if (
                    this.loadingSubcomponentIds.indexOf(fieldGroup.id) > 0
                  ) {
                    throw new Error(
                      'Error existe más de un grupo en la definicion del formulario con id:' +
                      fieldGroup.id
                    );
                  } else {
                    console.log(
                      'Grupo ',
                      fieldGroup.id,
                      ' registrado para la espera'
                    );
                    this.loadingSubcomponentIds.push(fieldGroup.id);
                  }
                }
              );
              this.createFormInterface(formConfig);

              //<--
            });




        });
    } else {
      // Por aquí pasan
      // Los formularios que hacen merge y llegan configurados
      // o un editorconfig que se abre
      console.log(
        'Generando formlario con interfaceSettings preconfigurado',
        formConfig.interfaceSetting
      );
      if (formConfig.baseInterfaceSettingsId) {

        this.subscribe(this.helpService.searchByForm(formConfig.baseInterfaceSettingsId, [formConfig.model]),
          result => {
            if (result && result.content) {
              result.content.forEach((element: HelpElementDTO) => {
                element.tags.forEach(tags => {
                  let tagArray = tags.split('&');
                  tagArray.forEach((value, index) => {
                    if (value.startsWith('FLD_') && index + 1 < tagArray.length) {
                      formConfig.interfaceSetting.fieldGroups.forEach(group => {
                        group.fieldList.filter((field: FieldConfig) => field.jsonField == tagArray[index + 1])
                          .forEach((field: FieldConfig) => {
                            if (!field.helpEntries) {
                              field.helpEntries = [];
                            }
                            field.helpEntries.push(tagArray[index]);
                            field.helpEntries.push(tagArray[index + 1]);
                          });
                      });
                    }
                  });
                });
              });
            }
          });
        formConfig.interfaceSetting.fieldGroups.forEach(group =>
          group.fieldList.forEach((field: FieldConfig) => {
            field.formId = formConfig.baseInterfaceSettingsId;
            field.showInfo = (this.userService.hasRoles('0,50') && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags);
          }));
        this.createFormInterface(formConfig);

      } else {
        this.createFormInterface(formConfig);
      }
    }


  }

  isLoaded() {
    return this.loaded && this.loadingSubcomponentIds.length === 0;
  }

  // public close() {
  //   console.log('cerrar');
  //   if (!this.formGroup.pristine) {
  //     this.confirmationService.confirm({
  //       message: this.translate.instant('General.discard.changes'),
  //       accept: () => {
  //         this.ref.close(this.context['model']);
  //       }
  //     });
  //   } else {
  //     this.ref.close(this.context['model']);
  //   }
  // }

  public getFormGroupConfig(group: FieldGroup): FormGroupConfig {
    return new FormGroupConfig(group, this.formConfig.model);
  }

  public deleteFormErrors() {
    if (this.formGroup) {
      this.formService.clearFormControlError(this.formGroup)
    }
    if (this.errorForm) {
      this.errorForm.cleanErrors();
    }
    if (this.formGroup && this.formService) {
      this.formService.markFormGroupTouched(this.formGroup);
    }
    if (
      this.formConfig &&
      this.formConfig.interfaceSetting &&
      this.formConfig.interfaceSetting.fieldGroups
    ) {
      this.formConfig.interfaceSetting.fieldGroups.forEach(
        (fieldGroup: FieldGroup) => {
          if (fieldGroup.fieldList) {
            fieldGroup.fieldList.map((fieldConfig: FieldConfig) => fieldConfig.abstractControl)
              .forEach((control: AbstractControl) => {
                if (control) {
                  this.formService.setFormControlError(control, null);
                }
              });
          }
          this.formService.deleteModelErrors(
            this.getFormGroupConfig(fieldGroup)
          );
        }
      );
    }
    this.updateGroupView(true);
  }

  public executeAction(action: FormAction<any>, event?: Event): void {
    console.log('ACCION en formplyca', action);
    this.errorForm.cleanErrors();
    if (action) {
      this.subscribe(action
        .executeFormAction(this.formConfig.model),
        // .pipe(
        //   finalize(() => {
        //     console.log('Se cierra la modal del formPlyca');
        //   })
        // ),
        (x: any) => {
          // marcar los campos como modificados y limpiar
          this.formGroup.markAsPristine();
          this.deleteFormErrors();
          console.log('this.ref .............');
          console.log(this.ref);
          if (this.ref != undefined && action.closeOnSuccess) {
            let dialogResponse = new FormDialogResponse();
            dialogResponse.actionId = action.actionId;
            dialogResponse.model = this.formConfig.model;
            /* if (event) {
               event.preventDefault();
             }*/
            this.ref.close(dialogResponse);
          }
        },
        error => {
          // this.manageFormException(error);
          this.manageFormException(error);
          return of(error);
        }
      );
    } else {
      this.formGroup.markAsPristine();
      //      this.close();
    }
  }

  public manageFormException(error: any, showMessage = true) {
    this.deleteFormErrors();

    if (!this.formGroup) {
      this.load(this.formConfig);
      return;
    }

    const formExceptionHandled = this.formService.manageFormException(
      error,
      this.formConfig.interfaceSetting.fieldGroups,
      this.formGroup,
      this.formConfig.model
    );

    if (formExceptionHandled) {
      this._handleFormException();
    } else if (showMessage) {
      this.plycaErrorHandler.showServerError(error);
    }
    if (this.formConfig.interfaceSetting.updateMode === FormUpdateMode.ONCHANGE) {
      this.updateGroupView(true);
    }
  }

  private _handleFormException(): void {
    const formGroupformConfig = this._buildFormGroupConfig();
    this.populateErrorForm(
      this.errorForm,
      formGroupformConfig,
      this.formGroup,
      this.formConfig
    );

    if (this.formConfig.showValidations) {
      this.showValidationsPanel = true;
    }
  }

  private _buildFormGroupConfig(): FormGroupConfig[] {
    return this.formConfig.interfaceSetting.fieldGroups.map((fieldGroup: FieldGroup) => {
      fieldGroup.formGroup = this.formGroup;
      return new FormGroupConfig(fieldGroup, this.formConfig.model);
    });
  }

  private populateErrorForm(
    errorForm: ErrorForm,
    groups: FormGroupConfig[],
    formGroup: AbstractControl,
    formConfig: FormConfig
  ): ErrorForm {
    if (formGroup.errors && formGroup.errors.server) {
      let unmappedErrors = [];
      formGroup.errors.server.forEach((error: any) => {
        unmappedErrors.push(new ErrorDefinition(error.message, error.result));
      });
      errorForm.unmappedErrors = unmappedErrors;
    }
    groups.forEach((groupConfig: FormGroupConfig) =>
      errorForm.fieldGroups.push(this.toErrorFieldGroup(groupConfig.group, formConfig))
    );
    return errorForm;
  }

  private toErrorFieldGroup(group: FieldGroup, formConfig: FormConfig): ErrorFieldGroup {
    // let errorFieldGroups = new ErrorFieldGroup(group);
    // errorFieldGroups.description = this.getDescription(group.description);
    // errorFieldGroups.elementId = group.id;
    // group.fieldList
    //   .filter((field: FieldConfig) => field.abstractControl && field.abstractControl.errors)
    //   .forEach((field: FieldConfig) => errorFieldGroups.fields.push(this.toErrorField(field)));
    // return errorFieldGroups;
    return new ErrorFieldGroup(group, formConfig.model, formConfig.functions);
  }

  validate(validationGroup: string, model?: any) {
    this.subscribe(this.getValidateObservable(validationGroup, model));
  }

  getValidateObservable(validationGroup: string, model?: any): Observable<any> {
    if (!model) {
      model = this.formConfig.model;
    }
    console.log(
      'Validando formulario. Esquema utilizado:' + validationGroup,
      model
    );

    return this.plycaService.validateDTO(validationGroup, model).pipe(
      tap(validations => {
        if (getResultTypeDTOLevel(validations.body.result) !== getResultTypeDTOLevel(ResultTypeDTO.OK)) {
          this.manageFormException(validations.body);

        } else if (!this.formConfig.showValidations) {
          this.uiService.showMessage(
            this.translate.instant('GenericDossier.validate.ok'),
            this.translate.instant('General.info'),
            'helpStyle'
          );
        }
      }),
      catchError((error: any) => {
        console.log('manageFormException 2', error);
        this.manageFormException(error);
        return throwError(error);
      })
    );
  }


  public markGroupAsLoaded(id: string): void {
    if (id) {
      console.log('Grupo ', id, ' cargado');
      this.markSubcomponentAsLoaded(id);
      this.updateLoadedGroups();
      if (this.isLoaded()) {
        console.log('Formulario plyca cargado ');
        this.formLoaded = true;
        this.completed.next(true);
        if (this.manageWaitService && this.loadingSubcomponentIds.length === 0) {
          this.waitService.cancelWaiting();
        }
        if (this.formConfig.readonly == false) {
          // Si se ha cargado completamente forzamos el foco en el primer componente
          this.focusTrap
            .create(this.elem.nativeElement)
            .focusFirstTabbableElementWhenReady()
            .then(focussed => {
              console.log('**** Foco en -> ' + document.activeElement);
            });
        }


        this.formGroup.markAsPristine();
      }
      console.log(
        'En el formulario de plyca quedan los siguientes grupos por cargar',
        this.loadingSubcomponentIds
      );
    }
  }

  private updateLoadedGroups(): void {
    // eliminar de grupos pendientes de carga los no visibles
    this.groups.forEach((group: FormGroupConfig) => {
      if (!this.formService.isVisible(group, this.formConfig)) {
        this.markSubcomponentAsLoaded(group.group.id);
      }
    });
  }
  private markSubcomponentAsLoaded(id: string) {
    this.loadingSubcomponentIds = this.loadingSubcomponentIds.filter(
      (componentId: string) => componentId !== id
    );
  }
  public getCompleted(): Observable<boolean> {
    return this.completed.asObservable();
  }

  restoreHelpContext() {
    if (
      this.headerActionsService.getParentSavedHelpTags(this.windowHash) !=
      undefined
    ) {
      this.helpService.showContextHelpObservable(
        this.headerActionsService.getParentSavedHelpTags(this.windowHash)
      ).pipe(take(1)).subscribe();
    } else {
      this.helpService.clearContextHelp();
    }

    console.log(
      'TAGS RECUPERADOS:' +
      this.headerActionsService.getParentSavedHelpTags(this.windowHash)
    );
  }
  setModalHelpContext() {

    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        tap((helpTags) => {

          this.headerActionsService.setParentSavedHelpTags(
            helpTags,
            this.windowHash
          );
        }
        )));

    if (this.formConfig.searchTags != undefined) {
      this.subscribe(this.helpService.showContextHelpObservable(this.formConfig.searchTags));
    } else {
      this.helpService.clearContextHelp();
    }

    console.log(
      'TAGS GUARDADOS:' +
      this.headerActionsService.getParentSavedHelpTags(this.windowHash)
    );
  }

  ngOnDestroy(): void {
    console.log('bye');
    if (this.isModalWindow) {
      this.formConfig.showValidations = false;
      this.headerActionsService.clearWindowActions(this.windowHash);
      this.restoreHelpContext();
    }
    this.changeDetectorRef.detach();
    // eliminar referencias a funciones y templates de FormConfig
    FormConfig.destroy(this.formConfig);
    this.formConfig = null;
    this.formGroup = null;
    this.groups = null;
    this.errorForm = null;
    this.elem = null;
    this.ref = null;
    // completar para forzar baja suscripcion
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    this.completed.complete();
    super.ngOnDestroy();
  }

  closeValidationsPanel() {
    this.showValidationsPanel = false;
  }

  public getVisibleGroups(): FormGroupConfig[] {
    let visibleGroup = new Array<FormGroupConfig>();
    this.groups.forEach((group: FormGroupConfig) => {
      if (this.formService.isVisible(group, this.formConfig)) {
        visibleGroup.push(group);
      } else if (!this.formLoaded) {
        console.log('Eliminando grupo ' + group.group.id + ' de los pendientes de cargar por invisible');
        this.markSubcomponentAsLoaded(group.group.id);
      }
    });
    return visibleGroup;
  }

  public activateOnlyOneGroup(event: { originalEvent: Event, index: number }): void {
    this.getVisibleGroups().forEach((group: FormGroupConfig, index: number) => {
      group.group.active = index === event.index;
    });
  }

  public openAccordion(event: { originalEvent: Event, index: number }): void {
    this.getVisibleGroups().forEach((group: FormGroupConfig, index: number) => {
      if (index === event.index) {
        group.group.active = true;
      }
    });
  }

  public closeAccordion(event: { originalEvent: Event, index: number }): void {
    this.getVisibleGroups().forEach((group: FormGroupConfig, index: number) => {
      if (index === event.index) {
        group.group.active = false;
      }
    });
  }

  public getVisibleFieldGroups(): FieldGroup[] {
    return this.getVisibleGroups().map((grpConfig: FormGroupConfig) => grpConfig.group);
  }

  public selectedGroupFromIndex(group: FieldGroup): void {
    this.showIndex = false;
    this.formService.navigateToGroup(group)
  }

  public selectedFieldFromIndex(field: FieldConfig): void {
    this.showIndex = false;
    this.formService.navigateToField(field);
  }

  /**
   * Metodo al que se invoca cada vez que un control envia señal de actualizacion
   * @param value
   */
  public sendUpdateView(value: any): void {
    this.viewUpdates.next(value);
  }

  /**
   * Metodo de actualizacion de la vista invocado desde el constructos para
   * ignorar peticiones consecutivas en un intervalo
   * @param value
   */
  private updateGroupView(value: any): void {
    if (value) {
      console.log('actualizando vista del formulario');
      this.lastChangesApplied = new Date();
      this.changeDetectorRef.detectChanges();
    }
  }

  public hideGroup(evt: VisibilityEvent): void {
    this.emptyGroup.set(evt.id, !evt.visible);
    this.updateGroupView(true);
  }

}
